// Performance Explorer option sets. `id` values are the backend's query-param
// values; `label` is what the UI shows.

export const METRIC_OPTIONS = [
  // Volume is dollar-denominated (sum of claim amounts), not an RO count — the
  // count for the same bucket is its own column in the Detailed Data table.
  { id: 'ro_volume', label: 'Total RO Volume ($)' },
  { id: 'rework_rate', label: 'Rework Rate %' },
  { id: 'avg_cycle_time', label: 'Avg Cycle Time' },
]

export const GRANULARITY_OPTIONS = [
  { id: 'daily', label: 'Daily' },
  { id: 'weekly', label: 'Weekly' },
  { id: 'monthly', label: 'Monthly' },
]

// Technician grouping is intentionally deferred (RO-level metrics over a
// per-line-item dimension is ambiguous when an RO spans techs).
export const GROUP_BY_OPTIONS = [
  { id: 'none', label: 'None' },
  { id: 'advisor', label: 'Advisor' },
]

const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

// Compact form for axis ticks — "$1,204,882.00" is far too wide for a y-axis
// label at the dollar volumes this runs at.
const compactCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  // min 0 as well as max 1: without it USD's 2-digit default is clamped to a
  // fixed 1, so a zero tick renders "$0.0" and a small one "$500.0".
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
})

// Per-metric value formatting for the chart tooltip and table.
// `?? 0` rather than `|| 0`: an absent bucket value should read as $0.00, but a
// NaN should render as NaN and get reported. A dollar figure that silently says
// $0.00 when the data is broken is worse than a visibly wrong one — it looks
// like a real answer, and someone makes a call on it.
export const METRIC_VALUE_FORMAT = {
  ro_volume: (v) => currency.format(v ?? 0),
  rework_rate: (v) => `${v}%`,
  avg_cycle_time: (v) => `${v}d`,
}

// Axis-tick formatting. Same as the table except for volume, which compacts.
export const METRIC_AXIS_FORMAT = {
  ...METRIC_VALUE_FORMAT,
  ro_volume: (v) => compactCurrency.format(v ?? 0),
}

export const METRIC_LABEL = METRIC_OPTIONS.reduce(
  (acc, { id, label }) => ({ ...acc, [id]: label }),
  {},
)
